import React, { useState } from "react";

const ReadMoreText = ({ text, maxLength = 50, className = "" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text || text === "NA") {
    return <span className={className}>NA</span>;
  }

  const shouldShowReadMore = text?.length > maxLength;
  const displayText = isExpanded ? text : text?.slice(0, maxLength) + "...";

  return (
    <span className={className}>
      {displayText}

      {shouldShowReadMore && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            fontSize: "12px",
            marginLeft: "5px",
            textDecoration: "underline",
            fontWeight: "500",
          }}
        >
          {isExpanded ? "View Less" : "Read More"}
        </button>
      )}
    </span>
  );
};

export default ReadMoreText;